<jml-lib-dynamic-table
  *ngIf="attachmentTableData"
  [tableData]="attachmentTableData"
  [isRootEntity]="false"
  [ownerId]="ownerId"
  [ownerType]="ownerType"
>
</jml-lib-dynamic-table>
